import type { ISubaccount } from '../../types';
import { Icon, IconName, type IconProps } from '../Icons';

export interface ISubAccountIconProps {
  selection?: ISubaccount | string | null;
  size?: IconProps['size'];
}

export function SubAccountIcon({ selection, size }: ISubAccountIconProps) {
  return <Icon icon={IconName.BookOpen} color={selection ? 'colors.blue.lighten' : 'colors.gray.080'} size={size} />;
}
